import { API_BASE_URL } from './apiConfig';

export async function fetchEvents({ start, end, event_type } = {}) {
  const token = localStorage.getItem('token');
  const params = new URLSearchParams();
  if (start) params.append('start', start);
  if (end) params.append('end', end);
  if (event_type) params.append('event_type', event_type);
  const res = await fetch(`${API_BASE_URL}/calendar/events?${params.toString()}`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    credentials: 'include',
  });
  if (!res.ok) throw new Error('Failed to fetch events');
  const data = await res.json();
  return data.events;
}

export async function createEvent(event) {
  const token = localStorage.getItem('token');
  
  const res = await fetch(`${API_BASE_URL}/calendar/events`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    credentials: 'include',
    body: JSON.stringify(event),
  });
  
  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to create event: ${res.status} ${res.statusText}`);
  }
  
  const data = await res.json();
  
  // If the backend returns eventId, fetch the complete event
  if (data.eventId && !data.event) {
    try {
      const eventRes = await fetch(`${API_BASE_URL}/calendar/events/${data.eventId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        credentials: 'include',
      });
      if (eventRes.ok) {
        const eventData = await eventRes.json();
        return eventData.event;
      }
    } catch (err) {
      console.error('Error fetching created event:', err);
    }
  }
  
  // Check if data.event exists, otherwise return the data directly
  return data.event || data;
}

export async function updateEvent(id, event) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE_URL}/calendar/events/${id}`, {
    method: 'PUT',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    credentials: 'include',
    body: JSON.stringify(event),
  });
  if (!res.ok) throw new Error('Failed to update event');
  const data = await res.json();
  return data.event;
}

export async function deleteEvent(id) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE_URL}/calendar/events/${id}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`
    },
    credentials: 'include',
  });
  if (!res.ok) throw new Error('Failed to delete event');
  return true;
} 